import React, { useState, useRef } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Paper,
  Snackbar,
  Alert,
  Button,
} from '@mui/material';
import { Save } from '@mui/icons-material';
import OnboardingData from './../../OnboardingData/OnboardingData';
import MainContentContainer from "../../MainContentContainer/MainContentContainer";

const OnboardingDataPage = () => {
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });
  const formRef = useRef(null);

  const handleCloseSnackbar = () => {
    setSnackbar(prev => ({ ...prev, open: false }));
  };

  const handleActionComplete = (success, message) => {
    setSnackbar({
      open: true,
      message,
      severity: success ? 'success' : 'error'
    });
  };

  const handleSave = () => {
    if (formRef.current) {
      formRef.current.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    }
  };

  return (
    <MainContentContainer>
      <AppBar position="sticky">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Tapping Basics
          </Typography>
          <Button
            color="inherit"
            onClick={handleSave}
            startIcon={<Save />}
            sx={{
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)'
              }
            }}
          >
            Save Changes
          </Button>
        </Toolbar>
      </AppBar>

      <Box sx={{ mt: 3 }}>
        <Paper sx={{ p: 3 }}>
          <OnboardingData
            onActionComplete={handleActionComplete}
            formRef={formRef}
          />
        </Paper>
      </Box>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </MainContentContainer>
  );
};

export default OnboardingDataPage;
